import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DashBoardService } from 'src/app/service/dashboard.service';

@Component({
  selector: 'app-userdashboarddetails',
  templateUrl: './userdashboarddetails.component.html'
})
export class UserdashboarddetailsComponent implements OnInit {

  errorMsg: string = '';
  EnergymeterID: any;
  UserwiseDashBoardDetails: any[] = [];
  windowheight: any;
  divHeight: number;
  tableHeight: number;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dashboardservice: DashBoardService, public dialogRef: MatDialogRef<UserdashboarddetailsComponent>) {
  }

  // Called when window resize
  onResize() {
    this.ResizeHeight();
  }

  // Called function on initial and window resize
  ResizeHeight() {
    this.windowheight = localStorage.getItem('WindowHeight');
    this.divHeight = this.windowheight - 130;
    this.tableHeight = this.divHeight - 110;
  }

  ngOnInit(): void {
    this.GetUserwiseDashBoardDetails();
  }

  //  Get User wise DashBoardDetails
  GetUserwiseDashBoardDetails() {
    this.dashboardservice.GetUserwiseDashBoardDetails().subscribe(
      (result) => {
        this.UserwiseDashBoardDetails = result;
      },
      (error) => {
        this.errorMsg = error;
      }
    );
  }

  // called on close icon
  Close() {
    this.dialogRef.close();
  }

}
